// hours in milliseconds: 1000 * 60 * 60
export const HOURS_MS = 3600000;

// minutes in milliseconds: 1000 * 60
export const MIN_MS = 60000;

/**
 * get server date parameters from hidden fields (in master page)
 */
export const getServerDate = () => {
    const day = Number(document.getElementById('current-day')?.innerText) || 1;
    const month = Number(document.getElementById('current-month')?.innerText) || 1;
    const year = Number(document.getElementById('current-year')?.innerText) || 0;
    const hour = Number(document.getElementById('current-hour')?.innerText) || 0;
    const minute = Number(document.getElementById('current-minute')?.innerText) || 0;
    const sec = Number(document.getElementById('current-sec')?.innerText) || 0;

    return new Date(year, month - 1, day, hour, minute, sec).getTime();
};

/**
 * add 0 to the left of the number (if needed)
 */
const twoDigits = (number: number) => {
    let result = parseInt(number + '').toString();
    if (result.length < 2) {
        result = '0' + result;
    }

    return result;
};

/**
 * difference's hour -> string
 */
export const getHours = (difference: number) => {
    const hours = difference / HOURS_MS;
    return twoDigits(hours);
};

/**
 * difference's minutes -> string
 */
export const getMinutes = (difference: number) => {
    const minutes = (difference % HOURS_MS) / MIN_MS;
    return twoDigits(minutes);
};

/**
 * difference's seconds -> string
 */
export const getSeconds = (difference: number) => {
    const seconds = (difference % HOURS_MS % MIN_MS) / 1000;
    return twoDigits(seconds);
};